import { React } from "react";
// import logo from "./logokopia.png";
// import logo2 from "./loggastor.jpeg";

function StartSida() {
return(
  <>
<section className="bg-beige-light ">
  <div className=" mx-auto px-6 mt-12">
    <div className="flex flex-col items-center rounded rounded-sm bg-cover bg-[position:center_top] justify-end text-center h-[350px] md:h-[650px] bg-[url(./loggastorkopia2.jpeg)]">
      
      {/* <img
        src={logo}
        alt="Frisörsalong Claire"
        className="w-48 md:w-56"
      /> */}
      <div className="md:p-20 p-10">
            <p className=" text-brown tracking-widest uppercase text-md md:text-xl">
              Hair · Beauty · Care
            </p>
          <a href="https://bokning.voady.se/studioclaire">
              <button  className="bg-beige-dark mt-6 px-10 md:px-14 md:py-5 py-3 rounded-full md:text-2xl text-xl text-brown font-medium uppercase hover:bg-brown hover:text-beige transition ">
                  Boka tid
              </button>
            </a>
      </div>
    </div>
  </div>
</section>
<section className="flex flex-col items-center py-8 px-6 bg-beige-light ">
<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8 sm:gap-16 md:gap-20 md:mt-12 md:mb-12 mb-6">
  <div className="mb-6 mt-6 flex md:items-center md:justify-center ">
    <p className="leading-relaxed md:leading-normal max-w-prose md:text-lg ">
      CLAIRÉ är en modern frisörsalong belägen på Centralgatan 17, mitt i centrala Sundsvall. Hos oss möts du av en lugn, personlig och avslappnad miljö där kvalitet och helhetskänsla står i fokus.<br/>
      <br/>
      Oavsett om du är ute efter en större förändring eller regelbunden vård, är vårt mål alltid att du ska lämna salongen med ett hår du trivs i och en känsla av att ha blivit väl omhändertagen.<br/>
      <br/>
      Varmt välkommen till oss på CLAIRÉ!
    </p>
  </div>
    <div className="">
    <img
      src="/bilder/bada.jpeg"
      alt="bildAmanda&Filippa"
      className="rounded rounded-sm w-full md:h-96 object-contain mx-auto"
      />
  </div>
  </div>
</section>
</>
);

}

export default StartSida;